import React, { useContext, useEffect, useState } from "react";
import {
  getAssignedProjects,
  getAllProjects,
  getAllSubcontractor,
  getEquipment,
  assignProject,
  addServicesToQuickbook,
  markCompleteProject,
} from "../../webServices/Apis";
import Loader from "../Loader/Loader";
import {
  message,
  Modal,
  Button,
  Form,
  Input,
  Select,
  Space,
  Descriptions,
} from "antd";
import { AiOutlineEye, AiFillEdit } from "react-icons/ai";
import { DatePicker } from "antd";
import { useNavigate } from "react-router";
import { UserContext } from "../../App";
import { Pagination, Tooltip } from "antd";
import moment from "moment";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { parseString } from "xml2js";
import UnassignTask from "./UnassignTask";

const AssignedProjects = () => {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);
  const [assignedProjectData, setAssignedProjectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [subContractor, setSubContractor] = useState("");
  const [equipment, setEquipment] = useState("");
  const [tasks, setTasks] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [allSelectedTask, setAllSelectedTask] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [action, setAction] = useState(false);
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const [taskIds, setTaskIds] = useState([]);
  const [selectedTaskBudget, setSelectedTaskBudget] = useState([]);
  const [notArchived, setNotArchived] = useState([]);

  const [showUnassignTask, setShowUnassignTask] = useState(false);

  const [selectedTaskName, setSelectedTaskName] = useState("");
  const [taskNameString, setTaskNameString] = useState("");

  const handleCheckboxChange = (task, taskName, taskBudget) => {
    let updatedTasks;
    if (selectedTasks?.includes(task)) {
      updatedTasks = selectedTasks?.filter((t) => t !== task);
    } else {
      updatedTasks = [...selectedTasks, task];
    }

    let updatedTaskNames;
    if (allSelectedTask?.includes(taskName)) {
      updatedTaskNames = allSelectedTask.filter((n) => n !== taskName);
    } else {
      updatedTaskNames = [...allSelectedTask, taskName];
    }

    let updatedTaskBudget;
    if (selectedTaskBudget?.includes(taskBudget)) {
      updatedTaskBudget = selectedTaskBudget.filter((b) => b !== taskBudget);
    } else {
      updatedTaskBudget = [...selectedTaskBudget, taskBudget];
    }

    setSelectedTasks(updatedTasks); // Update selected task IDs
    setAllSelectedTask(updatedTaskNames); // Update selected task names
    setSelectedTaskBudget(updatedTaskBudget);

    handleProjectName(updatedTasks); // Assuming this function does something with task IDs
  };

  useEffect(() => {}, [selectedProject]);

  // const handlemarkCompleted = async (project) => {
  //   try {
  //     setLoading(true);
  //     const response = await markCompleteProject(project.id);
  //     if (response?.data?.success) {
  //       message.success(response?.data?.message);
  //       handleAllProjects();
  //     }
  //   } catch (error) {
  //     console.log("Error while mark as complete", error.message);
  //     message.error(error?.response?.data?.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleEquipCheckboxChange = async (equipId) => {
    let updatedEquipment;

    if (selectedEquipments.includes(equipId)) {
      // If the equipment ID is already in the array, remove it
      updatedEquipment = selectedEquipments.filter((id) => id !== equipId);
    } else {
      // If the equipment ID is not in the array, add it
      updatedEquipment = [...selectedEquipments, equipId];
    }

    // Update the state with the new list of selected equipment IDs
    setSelectedEquipments(updatedEquipment);
  };

  const handleProjectChange = (project) => {
    if (!project) {
      return;
    }
    setSelectedProject(project);
  };

  const handleCreate = () => {
    form.resetFields(); // Reset the form fields
    setOpen(true);
  };

  const handleView = (project) => {
    console.log("view project", project);

    const isCompleted =
      project?.taskList?.length > 0
        ? project.taskList.every((task) => task.isPaidStatus === true)
        : false;

    // Optionally: Update project status locally to reflect in modal
    const updatedProject = {
      ...project,
      isPending: isCompleted ? "Completed" : "Pending",
    };
    setSelectedProject(updatedProject);
    setIsModalVisible(true);
  };

  const handleCancelModal = () => {
    setTasks([]);
    setTaskIds([]);
    setSelectedEquipments([]);
    setIsModalVisible(false);
    setOpen(false); // Close the add project modal
    setSelectedProject(null);
    setSelectedTaskBudget([]);
    setSelectedTasks([]);
  };

  const handleAllProjects = async () => {
    setLoading(true);
    try {
      const res = await getAssignedProjects();

      if (res?.data?.success) {
        // const reverseTask = [...res?.data?.data].reverse();
        const notArchved = res?.data?.data.filter(
          (data) => data?.projectArchiveStatus !== true
        );
        const sortedData = notArchved.sort(
          (a, b) => new Date(b.dueDate) - new Date(a.dueDate)
        );
        setAssignedProjectData(sortedData);
      }
    } catch (error) {
      console.log("Error while getting assigned projects", error);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnectionDATING
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.removeItem("token");
        setIsAuthenticated(false);
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired");
        localStorage.clear();
        setIsAuthenticated(false);
        window.location.href = "/login";
      } else {
        return;
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAllProjectsName = async () => {
    try {
      const response = await getAllProjects();
      if (response?.data?.success) {
        const selectedProjects = response?.data?.data?.filter(
          (data) => data?.isArchived !== true
        );
        setNotArchived(selectedProjects);
        console.log("looooohhhh", response?.data?.data);
        setProjectName(response?.data);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      // message.error(error?.response?.data?.message)
    } finally {
    }
  };

  const getSubcontractors = async () => {
    try {
      const response = await getAllSubcontractor();
      if (response?.data?.success) {
        setSubContractor(response?.data);
      }
    } catch (error) {
      console.error("Error fetching subcontractors:", error);
      // message.error(error?.response?.data?.message)
    } finally {
    }
  };

  const fetchEquipments = async () => {
    try {
      const response = await getEquipment();
      if (response.data.success) {
        setEquipment(response.data);
      }
    } catch (error) {
      console.error("Error fetching equipments:", error);
      // message.error(error?.response?.data?.message)
    } finally {
    }
  };

  const handleAddProject = async (values) => {
    // Ensure taskIds is always an array
    const tasksArray = Array.isArray(taskIds) ? taskIds : [taskIds];

    // Ensure selectedEquipments is always an array
    const equipmentsArray = Array.isArray(selectedEquipments)
      ? selectedEquipments
      : [selectedEquipments];

    const taskNamesString = allSelectedTask.map((task) => `${task}`).join(", ");

    // const taskName = [];
    // const Equipments = [];
    const apiData = {
      projectId: Number(values.projectName),
      userId: Number(values.subContractor),
      taskIds: tasksArray,
      equipmentIds: equipmentsArray, // Use the created equipmentsArray
      dueDate: values.dueDate.format("YYYY-MM-DD"), // format the date as needed
      // budget: Number(values.budget),
      qbServiceName: taskNamesString,
    };

    setLoading(true);
    try {
      // const selectedProjectBudget = projectName.data.filter(
      //   (selectedProject) => selectedProject.id === apiData.projectId
      // );

      // const selectedProjectTasks = assignedProjectData.filter(
      //   (project) => project.projectId === apiData.projectId
      // );

      // // Calculate total budget of already assigned tasks for the selected project
      // const totalBudgetUsed = selectedProjectTasks.reduce(
      //   (sum, task) => sum + task.budget,
      //   0 // Add the budget of each task
      // );

      // if (selectedProjectBudget[0].budget < apiData.budget + totalBudgetUsed) {
      //   message.error(
      //     "The sum of assigned tasks budget exeeds the project's overall budget"
      //   );
      //   return;
      // }

      const allSelectedTaskBudget = selectedTaskBudget.reduce(
        (sum, values) => sum + values,
        0
      );

      const values = {
        Name: taskNamesString,
        Type: "Service",
        UnitPrice: allSelectedTaskBudget,
        IncomeAccountRef: {
          value: 1,
        },
      };
      if (localStorage.getItem("access_token")) {
        // Send the data to QuickBooks
        const qbResponse = await addServicesToQuickbook(values);
        if (qbResponse.status !== 200) {
          message.error("Error while creating service on Quick Books");
          return;
        }
      }

      const response = await assignProject(apiData);

      if (response?.data?.success) {
        message.success(response?.data?.message);
        handleAllProjectsName();
        setTasks([]);
        setTaskIds([]);
        setSelectedEquipments([]);
        setIsModalVisible(false);
        setSelectedProject(null);
        setOpen(false);
        handleAllProjects();
        setSelectedTaskBudget([]);
        setSelectedTasks([]);
      }
    } catch (error) {
      const xmlStringData = error?.response?.data;
      if (xmlStringData && xmlStringData.includes("<?xml")) {
        const xmlString = xmlStringData.slice(
          "Error creating service item: ".length
        );
        parseString(xmlString, (err, result) => {
          if (err) {
            console.log("Error while converting data");
            return;
          }
          // console.log("Respodkc", result)
          const qbError =
            result?.IntuitResponse?.Fault[0]?.Error[0]?.Message[0];
          const showError = qbError.replace(
            " Error",
            " of this task on your quick-books account"
          );
          message.error(showError);
        });
        return;
      }

      if (error?.response?.status === 401) {
        message.error("Session Timeout !");
        localStorage.clear();
        window.location.href = "/login";
        return;
      } else {
        message.error(error.response?.data?.message || "An error occurred"); // Added fallback message
      }
    } finally {
      setLoading(false);
      // Optional: Any cleanup logic can go here if needed
    }
  };

  useEffect(() => {
    handleAllProjectsName();
    handleAllProjects();
    getSubcontractors();
    fetchEquipments();
  }, [action]);

  const handleProjectName = async (selectedProjectId) => {
    setTaskIds(selectedProjectId);

    try {
      const handleEquipCheckboxChange = async (equip) => {
        let updatedEquipment;
      };
      // Find the selected project from the list
      const selectedProject = projectName?.data?.find(
        (project) => project.id === selectedProjectId
      );

      if (selectedProject) {
        // Now send the selected project data or handle it as needed
        setTasks(selectedProject); // Example of setting tasks if necessary
      } else {
        // console.log("No project found with the selected ID.");
        return;
      }
    } catch (error) {
      console.error("Error processing selected project:", error);
    }
  };

  // useEffect(() => {
  //   console.log("Budgettttt", projectName.data);
  // }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAssignedTask = assignedProjectData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  function formatDate(dateString) {
    const date = new Date(dateString); // Parse the date string
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed, so add 1)
    const day = String(date.getDate()).padStart(2, "0"); // Get day
    const year = date.getFullYear(); // Get year

    return `${month}-${day}-${year}`; // Return formatted date as mm/dd/yyyy
  }

  const hanldeAssignedViewTask = (project) => {
    setSelectedProject(project);
    setShowUnassignTask(true);
  };

  return (
    <div>
      {loading && <Loader />}
      <div className="p-4">
        <div className="flex flex-row justify-between items-center">
          <h2 className="text-2xl font-bold mb-4">Tasks Management</h2>
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-10 rounded"
            onClick={handleCreate}
          >
            Assign Task
          </button>
        </div>

        <table className="min-w-full bg-white border border-gray-800 border-b-4 mt-7">
          <thead>
            <tr className="bg-gray-800 text-white">
              <th className="py-2 px-4 border-b text-center">Sr. No.</th>
              <th className="py-2 px-4 border-b text-center"> Project Name</th>
              <th className="py-2 px-4 border-b text-center">Sub Contractor</th>
              <th className="py-2 px-4 border-b text-center">
                Assigned Budget
              </th>
              <th className="py-2 px-4 border-b text-center">Due Date</th>
              <th className="py-2 px-4 border-b text-center">Status</th>
              <th className="py-2 px-4 border-b text-center">Tasks</th>
              <th className="py-2 px-4 border-b text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentAssignedTask?.length > 0 ? (
              currentAssignedTask?.map((project, index) => {
                const totalBudget = project?.taskList?.reduce(
                  (sum, task) => sum + (task?.taskBudget || 0),
                  0
                );

                // Check if all tasks are paid
                const isCompleted =
                  project?.taskList?.length > 0
                    ? project.taskList.every(
                        (task) => task.isPaidStatus === true
                      )
                    : false;

                return (
                  <tr
                    key={project.id}
                    className={`hover:bg-gray-50 text-center ${
                      index % 2 === 0 ? "bg-white" : "bg-gray-300"
                    }`}
                  >
                    <td className="py-2 px-4 border-b">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td className="py-2 px-4 border-b">
                      {project.projectName}
                    </td>
                    <td className="py-2 px-4 border-b">{project.userName}</td>

                    <td className="py-2 px-4 border-b">{totalBudget}</td>
                    <td className="py-2 px-4 border-b">
                      {project.dueDate ? formatDate(project.dueDate) : "N/A"}
                    </td>
                    <td className="py-2 px-4 border-b">
                      {isCompleted ? "Completed" : "Pending"}
                    </td>

                    <td className="py-2 px-4 border-b">
                      <button
                        onClick={() => hanldeAssignedViewTask(project)}
                        style={{
                          background: "gray",
                          color: "#fff",
                          borderRadius: "10px",
                          padding: "3px 10px",
                        }}
                      >
                        Edit Tasks
                      </button>
                    </td>

                    <td className="py-2 px-4 border-b justify-center">
                      <Tooltip title="Click to view assigned task details">
                        <button
                          onClick={() => handleView(project)}
                          className="mr-2 text-blue-500 hover:text-blue-700"
                        >
                          <AiOutlineEye className="text-xl" />
                        </button>
                      </Tooltip>
                      {/* <Tooltip title="Click to mark as complete">
                        <button
                          onClick={() => handlemarkCompleted(project)}
                          className="mr-2 text-blue-500 hover:text-blue-700"
                        >
                          <IoCheckmarkDoneCircle className="text-xl" />
                        </button>
                      </Tooltip> */}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="py-2 px-4 border-b text-center">
                  No task assigned
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="mt-4 flex justify-end">
          <Pagination
            current={currentPage}
            total={assignedProjectData.length}
            pageSize={itemsPerPage}
            onChange={handlePageChange}
          />
        </div>

        {showUnassignTask && (
          <UnassignTask
            showUnassignTask={showUnassignTask}
            setShowUnassignTask={setShowUnassignTask}
            selectedProject={selectedProject}
            action={action}
            setAction={setAction}
          />
        )}

        {/* Modal for Viewing Project Details */}
        {selectedProject && (
          <Modal
            title="Assigned Task Details"
            visible={isModalVisible}
            onCancel={handleCancelModal}
            footer={[
              <Button
                key="close"
                className="px-8 py-4 border-gray-800 bg-gray-200 hover:bg-gray-500 mt-3"
                onClick={handleCancelModal}
              >
                Close
              </Button>,
            ]}
          >
            <Descriptions bordered className="border border-gray-900 mt-4">
              <Descriptions.Item label="Project Name" span={3}>
                {selectedProject.projectName || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Budget" span={3}>
                {selectedProject?.taskList?.length > 0
                  ? `$${selectedProject.taskList?.reduce(
                      (sum, task) => sum + (task?.taskBudget || 0),
                      0
                    )}`
                  : "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Due Date" span={3}>
                {selectedProject.dueDate
                  ? formatDate(selectedProject.dueDate)
                  : "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Project Description" span={3}>
                {selectedProject.projectDescription || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Tasks Status" span={3}>
                {selectedProject.isPending || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Sub Contractor Name" span={3}>
                {selectedProject.userName || "N/A"}
              </Descriptions.Item>
              <Descriptions.Item label="Equipments" span={3}>
                {selectedProject.equipmentList &&
                selectedProject.equipmentList.length > 0
                  ? selectedProject.equipmentList.map((task, index) => (
                      <div key={index}>{task.equipmentName}</div>
                    ))
                  : "No Equipments available"}
              </Descriptions.Item>
              <Descriptions.Item label="Assigned Tasks" span={3}>
                {selectedProject.taskList && selectedProject.taskList.length > 0
                  ? selectedProject.taskList.map((task, index) => (
                      <div key={index}>{task.taskName}</div>
                    ))
                  : "No Tasks available"}
              </Descriptions.Item>
            </Descriptions>
          </Modal>
        )}

        {/* Modal for Adding Project */}
        <Modal
          title={isEditMode ? "Edit Assigned Task" : "Assign Task"}
          visible={open}
          onCancel={handleCancelModal}
          footer={null}
        >
          <Form form={form} layout="vertical" onFinish={handleAddProject}>
            <Form.Item
              name="projectName"
              label="Project Name"
              rules={[
                { required: true, message: "Please input project name!" },
              ]}
            >
              <Select onChange={(value) => handleProjectName(value)}>
                {notArchived.map((project) => (
                  <Select.Option key={project.id} value={project.id}>
                    {project.projectName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="subContractor"
              label="Sub Contractor"
              rules={[
                { required: true, message: "Please select a sub contractor!" },
              ]}
            >
              <Select>
                {subContractor?.data?.map((sub) => (
                  <Select.Option key={sub.id} value={sub.name}>
                    {sub.firstName + " " + sub.lastName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="taskName"
              label="Tasks"
              rules={[
                {
                  required: true,
                  validator: (_, value) =>
                    selectedTasks?.length > 0
                      ? Promise.resolve()
                      : Promise.reject(
                          new Error("Please select at least one task")
                        ),
                },
              ]}
            >
              {tasks?.tasks?.map((task) => (
                <div key={task?.id}>
                  <label>
                    <div className="flex gap-2 py-1">
                      <input
                        type="checkbox"
                        value={task?.task}
                        onChange={() =>
                          handleCheckboxChange(
                            task?.id,
                            task?.task,
                            task?.taskBudget
                          )
                        }
                        checked={
                          task?.isTaskAssigned ||
                          (selectedTasks?.includes?.(task?.id) ?? false)
                        } // Always checked if isTaskAssigned is true
                        disabled={task?.isTaskAssigned} // Disable if task.isTaskAssigned is true
                      />
                      {task?.task} - ${task?.taskBudget}
                    </div>
                  </label>
                </div>
              ))}
            </Form.Item>

            <Form.Item
              name="Equipments"
              label="Equipments"
              // rules={[
              //   {
              //     // required: true,
              //     // validator: (_, value) =>
              //     //   selectedEquipments.length > 0
              //     //     ? Promise.resolve()
              //     //     : Promise.reject(
              //     //         new Error("Please select at least one equipment")
              //     //       ),
              //   },
              // ]}
            >
              {equipment?.data?.map((equip) => (
                <div key={equip.id}>
                  <label>
                    <div className="flex gap-2 py-1">
                      <input
                        type="checkbox"
                        value={equip.equipmentName}
                        onChange={() => handleEquipCheckboxChange(equip.id)}
                        checked={selectedEquipments.includes(equip.id)}
                      />
                      {equip.equipmentName}
                    </div>
                  </label>
                </div>
              ))}
            </Form.Item>
            {/* <Form.Item
              name="budget"
              label="Budget"
             
            >
              <sapn>{taskBudget}</sapn>
            </Form.Item> */}
            <Form.Item
              name="dueDate"
              label="Due Date"
              className="w-full flex"
              rules={[{ required: true, message: "Please select due date!" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={(current) =>
                  current && current < moment().endOf("day")
                }
              />
            </Form.Item>
            <Space>
              <Button
                onClick={handleCancelModal}
                className="px-8 py-4 bg-gray-200 border-gray-800"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="px-8 py-4 border-blue-600"
              >
                {isEditMode ? "Update" : "Assign"}
              </Button>
            </Space>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AssignedProjects;
